import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import './index.css';

import Login from './pages/Login';
import Dashboard from './pages/admin/Dashboard';
import Products from './pages/admin/Products';
import Customers from './pages/admin/Customers';
import Employees from './pages/admin/Employees';
import AdminBills from './pages/admin/Bills';
import Billing from './pages/employee/Billing';
import MyBills from './pages/employee/MyBills';
import PaymentEntry from './pages/employee/PaymentEntry';
import Reports from './pages/admin/Reports';
import SupplierTracking from './pages/admin/SupplierTracking';
import AwsCostCalculator from './pages/AwsCostCalculator';

function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === 'admin' ? '/admin/dashboard' : '/employee/billing'} replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/aws-cost-calculator" element={<AwsCostCalculator />} />
      <Route path="/login" element={user ? <Navigate to={user.role === 'admin' ? '/admin/dashboard' : '/billing'} /> : <Login />} />
      <Route path="/admin/dashboard" element={<ProtectedRoute role="admin"><Dashboard /></ProtectedRoute>} />
      <Route path="/admin/products" element={<ProtectedRoute role="admin"><Products /></ProtectedRoute>} />
      <Route path="/admin/customers" element={<ProtectedRoute role="admin"><Customers /></ProtectedRoute>} />
      <Route path="/admin/employees" element={<ProtectedRoute role="admin"><Employees /></ProtectedRoute>} />
      <Route path="/admin/bills" element={<ProtectedRoute role="admin"><AdminBills /></ProtectedRoute>} />
      <Route path="/admin/suppliers" element={<ProtectedRoute role="admin"><SupplierTracking /></ProtectedRoute>} />
      <Route path="/admin/reports" element={<ProtectedRoute role="admin"><Reports /></ProtectedRoute>} />
      <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
      <Route path="/employee/bills" element={<ProtectedRoute role="employee"><MyBills /></ProtectedRoute>} />
      <Route path="/employee/products" element={<ProtectedRoute role="employee"><Products /></ProtectedRoute>} />
      <Route path="/employee/payments" element={<ProtectedRoute role="employee"><PaymentEntry /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ style: { fontFamily: 'var(--font-body)', fontSize: '0.875rem', borderRadius: '8px', boxShadow: '0 4px 20px rgba(0,0,0,0.12)' }, success: { iconTheme: { primary: '#2d8a4e', secondary: '#fff' } } }} />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
